import axios from '@/utils/axiosHelper'

// 注销
export const onLogoutAPI = (params) => {
    return axios({ url: '/game/my/disable', method: 'POST', params }, { interceptResultCode: false })
}

// 初始化
export const onInitAPI = (params) => {
    return axios({ url: '/sea/america/million/index', method: 'GET', params }, { interceptResultCode: false })
}

// 抽奖
export const onDrawAPI = (params) => {
    return axios({ url: '/sea/america/million/draw', method: 'POST', params }, { interceptResultCode: false })
}

// 完成任务
export const onTaskAPI = (params) => {
    return axios({ url: '/sea/america/million/task', method: 'POST', params }, { interceptResultCode: false })
}

// 未登录信息
export const onInfoAPI = (params) => {
    return axios({ url: '/sea/america/million/info', method: 'GET', params }, { interceptResultCode: false })
}



// WEBPACK FOOTER //
// ./src/pages/snail/million/test/api.js